// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org%27 width=%2710%27 height=%2710%27 fill=%27%23bc13fe%27%3E%3Cpath d=%27M0 0l5 5 5-5H0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top.css */
.top-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px; /* Slimmer, professional height */
  padding: 0 15px;
  background-color: var(--bg-panel);
  border-bottom: 1px solid var(--border-color);
  color: var(--text-main);
  z-index: 1000;
}

/* --- LEFT SECTION (Branding & Breadcrumbs) --- */
.top-left {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
}

.tenant-branding {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #252525;
  border-radius: 4px;
  padding: 2px;
}

.top-left span {
  color: var(--text-dim);
}

.top-left span:last-child {
  color: var(--accent); /* Highlights the current section */
  font-weight: 600;
}

/* --- CENTER SECTION (Search) --- */
.top-center {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 400px; /* Grow to 400px but don't force it */
}

.top-search-input {
  width: 100%;
  background: #111;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 6px 30px 6px 12px;
  color: #eee;
  font-size: 13px;
  transition: all 0.2s;
}

.top-search-input:focus {
  border-color: var(--accent);
  background: #000;
  outline: none;
  box-shadow: 0 0 0 2px rgba(61, 90, 254, 0.2);
}

.clear-search-btn {
  position: absolute;
  right: 8px;
  background: transparent;
  border: none;
  color: #555;
  cursor: pointer;
  font-size: 12px;
}

.clear-search-btn:hover { color: #fff; }

/* --- RIGHT SECTION (Controls & User) --- */
.top-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.top-right select {
  background: #1a1a1a;
  color: var(--text-dim);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
}

.top-right select:hover { border-color: #444; }

.create-btn {
  background: var(--accent);
  color: white;
  border: none;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
}

.create-btn:hover { filter: brightness(1.2); }

/* User Menu */
.user-btn-container { position: relative; }

.user-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid transparent;
  background: #333;
  color: white;
  cursor: pointer;
  font-weight: bold;
}

.user-btn.logged-in { border-color: #4caf50; }
.user-btn.logged-out { border-color: #f44336; }

.user-menu {
  position: absolute;
  top: 35px;
  right: 0;
  width: 200px;
  background: #1e1e1e;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.5);
  font-size: 12px;
  color: #ccc;
}

.user-menu button {
  width: 100%;
  margin-top: 10px;
  background: #333;
  color: white;
  border: none;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}

.user-menu button:hover { background: #444; }
.top-left span:nth-child(3) {
  color: #00d4ff !important; 
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
}

/* Section Label: Electric Purple (High visibility) */
.top-left span:last-child {
  color: #bc13fe !important; 
  font-size: 14px;
  text-shadow: 0 0 8px rgba(188, 19, 254, 0.3); /* Subtle glow */
}

/* Top.css - High Contrast Selects */

.top-right select {
  background-color: #000000 !important; /* Deepest black */
  color: #00d4ff !important;           /* Electric Sky Blue */
  border: 2px solid #bc13fe !important; /* Neon Purple Border */
  border-radius: 6px;
  padding: 4px 24px 4px 10px;          /* Extra right padding for arrow */
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  appearance: none;                    /* Removes default browser arrow */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  transition: all 0.2s ease;
  outline: none;
}

/* Hover & Focus states */
.top-right select:hover {
  border-color: #00d4ff !important;    /* Swaps to Blue on hover */
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.top-right select:focus {
  border-color: #ffffff !important;    /* White glow when active */
}

/* THE DROPDOWN LIST (Options) */
.top-right select option {
  background-color: #111111 !important; /* Dark grey for the list */
  color: #ffffff !important;           /* White text for options */
  padding: 10px;
  font-weight: normal;
}

/* Special Case: The first "Selected" option color */
.top-right select option:checked {
  background-color: #bc13fe !important; /* Purple highlight for active choice */
  color: #fff !important;
}

.login-menu {
  width: 220px; /* Slightly wider for the info */
}

.user-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  transition: background 0.2s;
}

.user-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  color: white;
}

.admin { background: #e74c3c; } /* Red for Admin */
.viewer { background: #3498db; } /* Blue for Viewer */

.user-info {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.user-role {
  font-size: 11px;
  color: #777;
}

.add-account {
  color: #0078d4; /* C# / Windows Blue */
  font-size: 13px;
  padding: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Top/Top1.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY,EAAE,iCAAiC;EAC/C,eAAe;EACf,iCAAiC;EACjC,4CAA4C;EAC5C,uBAAuB;EACvB,aAAa;AACf;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB,EAAE,mCAAmC;EACzD,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe,EAAE,qCAAqC;AACxD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,0BAA0B,WAAW,EAAE;;AAEvC,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,0BAA0B,kBAAkB,EAAE;;AAE9C;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA,oBAAoB,uBAAuB,EAAE;;AAE7C,cAAc;AACd,sBAAsB,kBAAkB,EAAE;;AAE1C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB,qBAAqB,EAAE;AAC7C,uBAAuB,qBAAqB,EAAE;;AAE9C;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0BAA0B,gBAAgB,EAAE;AAC5C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,eAAe;EACf,4CAA4C,EAAE,gBAAgB;AAChE;;AAEA,oCAAoC;;AAEpC;EACE,oCAAoC,EAAE,kBAAkB;EACxD,yBAAyB,YAAY,sBAAsB;EAC3D,oCAAoC,EAAE,uBAAuB;EAC7D,kBAAkB;EAClB,0BAA0B,WAAW,kCAAkC;EACvE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB,qBAAqB,kCAAkC;EACvE,yDAAgK;EAChK,4BAA4B;EAC5B,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,gCAAgC,KAAK,2BAA2B;EAChE,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC,KAAK,2BAA2B;AAClE;;AAEA,gCAAgC;AAChC;EACE,oCAAoC,EAAE,2BAA2B;EACjE,yBAAyB,YAAY,2BAA2B;EAChE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,oCAAoC,EAAE,uCAAuC;EAC7E,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA,SAAS,mBAAmB,EAAE,EAAE,kBAAkB;AAClD,UAAU,mBAAmB,EAAE,EAAE,oBAAoB;;AAErD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,eAAe;EACf,aAAa;AACf","sourcesContent":["/* Top.css */\n.top-panel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 40px; /* Slimmer, professional height */\n  padding: 0 15px;\n  background-color: var(--bg-panel);\n  border-bottom: 1px solid var(--border-color);\n  color: var(--text-main);\n  z-index: 1000;\n}\n\n/* --- LEFT SECTION (Branding & Breadcrumbs) --- */\n.top-left {\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.tenant-branding {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #252525;\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.top-left span {\n  color: var(--text-dim);\n}\n\n.top-left span:last-child {\n  color: var(--accent); /* Highlights the current section */\n  font-weight: 600;\n}\n\n/* --- CENTER SECTION (Search) --- */\n.top-center {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 0 1 400px; /* Grow to 400px but don't force it */\n}\n\n.top-search-input {\n  width: 100%;\n  background: #111;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 6px 30px 6px 12px;\n  color: #eee;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.top-search-input:focus {\n  border-color: var(--accent);\n  background: #000;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(61, 90, 254, 0.2);\n}\n\n.clear-search-btn {\n  position: absolute;\n  right: 8px;\n  background: transparent;\n  border: none;\n  color: #555;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.clear-search-btn:hover { color: #fff; }\n\n/* --- RIGHT SECTION (Controls & User) --- */\n.top-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.top-right select {\n  background: #1a1a1a;\n  color: var(--text-dim);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.top-right select:hover { border-color: #444; }\n\n.create-btn {\n  background: var(--accent);\n  color: white;\n  border: none;\n  width: 26px;\n  height: 26px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.create-btn:hover { filter: brightness(1.2); }\n\n/* User Menu */\n.user-btn-container { position: relative; }\n\n.user-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  background: #333;\n  color: white;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.user-btn.logged-in { border-color: #4caf50; }\n.user-btn.logged-out { border-color: #f44336; }\n\n.user-menu {\n  position: absolute;\n  top: 35px;\n  right: 0;\n  width: 200px;\n  background: #1e1e1e;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 12px;\n  box-shadow: 0 10px 25px rgba(0,0,0,0.5);\n  font-size: 12px;\n  color: #ccc;\n}\n\n.user-menu button {\n  width: 100%;\n  margin-top: 10px;\n  background: #333;\n  color: white;\n  border: none;\n  padding: 6px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.user-menu button:hover { background: #444; }\n.top-left span:nth-child(3) {\n  color: #00d4ff !important; \n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n}\n\n/* Section Label: Electric Purple (High visibility) */\n.top-left span:last-child {\n  color: #bc13fe !important; \n  font-size: 14px;\n  text-shadow: 0 0 8px rgba(188, 19, 254, 0.3); /* Subtle glow */\n}\n\n/* Top.css - High Contrast Selects */\n\n.top-right select {\n  background-color: #000000 !important; /* Deepest black */\n  color: #00d4ff !important;           /* Electric Sky Blue */\n  border: 2px solid #bc13fe !important; /* Neon Purple Border */\n  border-radius: 6px;\n  padding: 4px 24px 4px 10px;          /* Extra right padding for arrow */\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  appearance: none;                    /* Removes default browser arrow */\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org' width='10' height='10' fill='%23bc13fe'%3E%3Cpath d='M0 0l5 5 5-5H0z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n/* Hover & Focus states */\n.top-right select:hover {\n  border-color: #00d4ff !important;    /* Swaps to Blue on hover */\n  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);\n}\n\n.top-right select:focus {\n  border-color: #ffffff !important;    /* White glow when active */\n}\n\n/* THE DROPDOWN LIST (Options) */\n.top-right select option {\n  background-color: #111111 !important; /* Dark grey for the list */\n  color: #ffffff !important;           /* White text for options */\n  padding: 10px;\n  font-weight: normal;\n}\n\n/* Special Case: The first \"Selected\" option color */\n.top-right select option:checked {\n  background-color: #bc13fe !important; /* Purple highlight for active choice */\n  color: #fff !important;\n}\n\n.login-menu {\n  width: 220px; /* Slightly wider for the info */\n}\n\n.user-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  transition: background 0.2s;\n}\n\n.user-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 14px;\n  color: white;\n}\n\n.admin { background: #e74c3c; } /* Red for Admin */\n.viewer { background: #3498db; } /* Blue for Viewer */\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-name {\n  font-weight: 600;\n  font-size: 14px;\n  color: #333;\n}\n\n.user-role {\n  font-size: 11px;\n  color: #777;\n}\n\n.add-account {\n  color: #0078d4; /* C# / Windows Blue */\n  font-size: 13px;\n  padding: 10px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
